import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// import { getIeHeatmap, sortIeHeatmap } from '../../actions';

import {
    selectApiCount,
    getErrorInfo,
    selectEmpExpResurveyData,
    selectEmpExpResurveyDatFetched,
    selectProjects,
    selectProjectsFetched,
    selectApiParams,
    selectFilters,
    selectFootnoteList,
    selectCompYrSettings,
    selectCompType,
    selectCompTypeFetched,
} from '../../selector';

import IndExpScorecard from './IndExpScorecard';
import { getDefaultSettings } from '../../../Login/selector';
import {
    getBenchmarks,
    getComparisonYearSettings,
    getDemographics,
    getEmpExpResurveyData,
    getExBenchmarks,
    resetEmpExpResDataFetched,
    updateFilters,
    getCompType,
} from '../../actions';

const stateToProps = createStructuredSelector({
    apiLoadingCount: selectApiCount(),
    errorInfo: getErrorInfo(),
    defaultSettings: getDefaultSettings(),
    empExpResurveyData: selectEmpExpResurveyData(),
    empExpResurveyDataFetched: selectEmpExpResurveyDatFetched(),
    projects: selectProjects(),
    projectsFetched: selectProjectsFetched(),
    apiParams: selectApiParams(),
    filters: selectFilters(),
    footnoteList: selectFootnoteList(),
    compYrSettings: selectCompYrSettings(),
    compType: selectCompType(),
    compTypeFetched: selectCompTypeFetched(),
});

const dispatchToProps = {
    getEmpExpResurveyData,
    resetEmpExpResDataFetched,
    getDemographics,
    getBenchmarks,
    updateFilters,
    getExBenchmarks,
    getComparisonYearSettings,
    getCompType,
};

export default connect(stateToProps, dispatchToProps)(IndExpScorecard);
